import { gql } from './gql'

/**
 * One order, in full.
 *
 * Session-scoped like `getOrders`: `sessionUid` is what authorises the read,
 * so an id belonging to another shopper resolves to nothing rather than to
 * someone else's order.
 *
 * Both line shapes are selected. An order carries `groups[].items` and an empty
 * `items` on a storefront whose cart is grouped — `prueba` groups by payment
 * method — exactly as the cart does, so reading only `items` shows an order
 * with no products and a real total. `cartLineItemsOf` reconciles the two.
 */
export const GET_ORDER = gql`
  query GetOrder($storefrontName: String!, $sessionUid: ID!, $id: ID!) {
    order(storefrontName: $storefrontName, sessionUid: $sessionUid, id: $id) {
      id
      status
      total
      sequence
      externalRefNumber
      createdAt
      items {
        sku
        name
        quantity
        price
      }
      groups {
        items {
          sku
          name
          quantity
          price
        }
      }
      checkoutRules {
        ruleType
        value
      }
    }
  }
`
